/* =========================================================
   ANALYZER V-201B FACEPLATE
========================================================= */

import React, {
  useState,
  useEffect
} from "react";

import { Rnd } from "react-rnd";

import "./MDSFaceplate.css";

/* =========================================================
   HELPERS
========================================================= */

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

/* =========================================================
   MAIN COMPONENT
========================================================= */

function AnalyzerV201BFaceplate({

  close = () => {},

  defaultPosition = {
    x: 260,
    y: 120
  }

}) {

  /* =========================================================
     ACTIVE TAB
  ========================================================= */

  const [activeTab, setActiveTab] =
    useState("inletParameters");

  /* =========================================================
     FACEPLATE POSITION
  ========================================================= */

  const [faceplatePos, setFaceplatePos] =
    useState(() => {

      const saved =
        localStorage.getItem(
          "AnalyzerV201B_faceplatePos"
        );

      return saved
        ? JSON.parse(saved)
        : defaultPosition;

    });

  /* =========================================================
     FACEPLATE SIZE
  ========================================================= */

  const [faceplateSize, setFaceplateSize] =
    useState(() => {

      const saved =
        localStorage.getItem(
          "AnalyzerV201B_faceplateSize"
        );

      return saved
        ? JSON.parse(saved)
        : {
            width: 900,
            height: 700
          };

    });

  /* =========================================================
     SAVE POSITION
  ========================================================= */

  useEffect(() => {

    localStorage.setItem(
      "AnalyzerV201B_faceplatePos",
      JSON.stringify(faceplatePos)
    );

  }, [faceplatePos]);

  /* =========================================================
     SAVE SIZE
  ========================================================= */

  useEffect(() => {

    localStorage.setItem(
      "AnalyzerV201B_faceplateSize",
      JSON.stringify(faceplateSize)
    );

  }, [faceplateSize]);

  /* =========================================================
     PROCESS DATA
  ========================================================= */

  const [processData, setProcessData] =
    useState({

      FIC_13001: 0,
      FIC_13002: 0,
      FIC_13003: 0,
      FIC_13004: 0,
      FIC_13005: 0,

      ZI_13001: 0,
      TT_13001: 0,

      MixValveOpening2: 0,

      inletSalt: 2,
      inletBSW: 0.05,
      inletWater: 0.05,
      inletSediment: 0.005,
      inletH2S: 0.8,

      inletInorganicChlorides: 0.2,
      inletOrganicChlorides: 0.9

    });

  /* =========================================================
     SINGLE INTERVAL
  ========================================================= */

  useEffect(() => {

    const interval = setInterval(() => {

      setProcessData({

        FIC_13001:
          Number(
            localStorage.getItem(
              "FIC_13001"
            )
          ) || 0,

        FIC_13002:
          Number(
            localStorage.getItem(
              "FIC_13002"
            )
          ) || 0,

        FIC_13003:
          Number(
            localStorage.getItem(
              "FIC_13003"
            )
          ) || 0,

        FIC_13004:
          Number(
            localStorage.getItem(
              "FIC_13004"
            )
          ) || 0,

        FIC_13005:
          Number(
            localStorage.getItem(
              "FIC_13005"
            )
          ) || 0,

        ZI_13001:
          Number(
            localStorage.getItem(
              "ZI_13001"
            )
          ) || 0,

        TT_13001:
          Number(
            localStorage.getItem(
              "TT_13001"
            )
          ) || 0,

        MixValveOpening2:
          Number(
            localStorage.getItem(
              "MixValveOpening2"
            )
          ) || 0,

      });

    }, 500);

    return () =>
      clearInterval(interval);

  }, []);

  /* =========================================================
     INPUTS
  ========================================================= */

  const crudeFlow =
    processData.FIC_13001;

  const decalcifierFlow =
    processData.FIC_13002;

  const demulsifierFlow =
    processData.FIC_13003;

  const washWaterFlow =
    processData.FIC_13004;

  const rinseWaterFlow =
    processData.FIC_13005;

  const gridVoltage =
    processData.ZI_13001;

  const desalterTemp =
    processData.TT_13001;

  const mixingValveOpening =
    processData.MixValveOpening2;

  /* =========================================================
     INLET FROM V201A
  ========================================================= */


  
// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

  
    const [saltOut, setsaltOut] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("saltOut")) || 0;
            setsaltOut(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

    const [bswOut, setbswOut] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("bswOut")) || 0;
            setbswOut(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

    const [waterOut, setwaterOut] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("waterOut")) || 0;
            setwaterOut(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

    const [sedimentOut, setsedimentOut] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("sedimentOut")) || 0;
            setsedimentOut(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

    const [h2sOut, seth2sOut] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("h2sOut")) || 0;
            seth2sOut(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

    const [organicChloridesOut, setorganicChloridesOut] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("organicChloridesOut")) || 0;
            setorganicChloridesOut(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

    const [inorganicChloridesOut, setinorganicChloridesOut] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("inorganicChloridesOut")) || 0;
            setinorganicChloridesOut(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);




  const inletSalt = saltOut;

  const inletBSW = bswOut;

  const inletWater = waterOut;

  const inletSediment = sedimentOut;

  const inletH2S = h2sOut ;

  const inletInorganicChlorides = organicChloridesOut;

  const inletOrganicChlorides = inorganicChloridesOut;

  /* =========================================================
     RATIOS
  ========================================================= */

  const washWaterRatio =
    crudeFlow > 0
      ? washWaterFlow / crudeFlow
      : 0;

  /* =========================================================
     EFFICIENCIES
  ========================================================= */

  const gridEfficiency =
    clamp(
      (gridVoltage / 35) * 100,
      0,
      100
    );

  let washEfficiency = 0;

  if(
    washWaterRatio >= 0.03 &&
    washWaterRatio <= 0.05
  ){

    washEfficiency = 100;

  }
  else if(
    washWaterRatio > 0
  ){

    washEfficiency = 65;

  }

  let mixingEfficiency = 0;

  if(
    mixingValveOpening >= 0.30 &&
    mixingValveOpening <= 0.60
  ){

    mixingEfficiency = 100;

  }
  else if(
    mixingValveOpening > 0
  ){

    mixingEfficiency = 60;

  }

  const demulsifierEfficiency =
    demulsifierFlow > 0
      ? 100
      : 20;

  const decalcifierEfficiency =
    decalcifierFlow > 0
      ? 100
      : 30;

  let temperatureEfficiency = 0;

  if(
    desalterTemp >= 120 &&
    desalterTemp <= 145
  ){

    temperatureEfficiency = 100;

  }
  else if(
    desalterTemp >= 90
  ){

    temperatureEfficiency = 70;

  }
  else{

    temperatureEfficiency = 30;

  }

  /* =========================================================
     OVERALL EFFICIENCY
  ========================================================= */

  const overallEfficiency =
  (
    gridEfficiency +
    washEfficiency +
    mixingEfficiency +
    demulsifierEfficiency +
    decalcifierEfficiency +
    temperatureEfficiency
  ) / 6;

  /* =========================================================
     FINAL OUTLET PARAMETERS
  ========================================================= */

  const FinalSaltOut =
  (
    inletSalt *
    (
      1 -
      (
        overallEfficiency / 100
      ) * 0.80
    )
  ).toFixed(2);

  const FinalBswOut =
  (
    inletBSW *
    (
      1 -
      (
        overallEfficiency / 100
      ) * 0.65
    )
  ).toFixed(3);

  const FinalWaterOut =
  (
    inletWater *
    (
      1 -
      (
        overallEfficiency / 100
      ) * 0.80
    )
  ).toFixed(3);

  const FinalSedimentOut =
  (
    inletSediment *
    (
      1 -
      (
        overallEfficiency / 100
      ) * 0.35
    )
  ).toFixed(4);

  const FinalInorganicChloridesOut =
  (
    inletInorganicChlorides *
    (
      1 -
      (
        overallEfficiency / 100
      ) * 0.92
    )
  ).toFixed(2);

  const FinalOrganicChloridesOut =
  (
    inletOrganicChlorides *
    (
      1 -
      (
        overallEfficiency / 100
      ) * 0.08
    )
  ).toFixed(2);

  const FinalH2sOut =
  (
    inletH2S *
    (
      1 -
      (
        overallEfficiency / 100
      ) * 0.12
    )
  ).toFixed(2);

  /* =========================================================
     SAVE FINAL OUTLET FOR OTHER SYSTEMS
  ========================================================= */

  useEffect(() => {

    localStorage.setItem(
      "V201B_saltOut",
      saltOut
    );

    localStorage.setItem(
      "V201B_bswOut",
      bswOut
    );

    localStorage.setItem(
      "V201B_waterOut",
      waterOut
    );

    localStorage.setItem(
      "V201B_sedimentOut",
      sedimentOut
    );

    localStorage.setItem(
      "V201B_h2sOut",
      h2sOut
    );

    localStorage.setItem(
      "V201B_inorganicOut",
      inorganicChloridesOut
    );

    localStorage.setItem(
      "V201B_organicOut",
      organicChloridesOut
    );

  }, [

    saltOut,
    bswOut,
    waterOut,
    sedimentOut,
    h2sOut,
    inorganicChloridesOut,
    organicChloridesOut

  ]);

  /* =========================================================
     UPSET CONDITIONS
  ========================================================= */

  const upsetConditions = [];

  if(gridVoltage <= 0){

    upsetConditions.push({

      title: "GRID OFF",

      impact:
        "No electrostatic coalescence. Water carryover increases."

    });

  }

  if(washWaterFlow <= 0){

    upsetConditions.push({

      title: "NO WASH WATER",

      impact:
        "Residual salt remains in desalted crude."

    });

  }

  if(mixingValveOpening > 0.80){

    upsetConditions.push({

      title: "EXCESSIVE MIXING",

      impact:
        "Stable emulsions generated causing rag layer increase."

    });

  }

  if(demulsifierFlow <= 0){

    upsetConditions.push({

      title: "LOW DEMULSIFIER",

      impact:
        "Poor dehydration and unstable interface."

    });

  }

  if(decalcifierFlow <= 0){

    upsetConditions.push({

      title: "LOW DECALCIFIER",

      impact:
        "Residual calcium salts remain in crude."

    });

  }

  if(desalterTemp < 110){

    upsetConditions.push({

      title: "LOW TEMPERATURE",

      impact:
        "Poor water settling due to high viscosity."

    });

  }

  const desalterStatus =
    upsetConditions.length === 0
      ? "GOOD DESALTER CONDITION"
      : "DESALTER UPSET CONDITION";

  /* =========================================================
     DATA ROW
  ========================================================= */

  const DataRow = ({
    label,
    value,
    unit
  }) => (

    <div className="mds-row">

      <div className="mds-key">
        {label}
      </div>

      <div className="mds-value-wrapper">

        <div className="mds-value-box">
          {value}
        </div>

        <div className="mds-unit-box">
          {unit}
        </div>

      </div>

    </div>

  );

  /* =========================================================
     SECTION RENDERER
  ========================================================= */

  const renderSection = () => {

    switch(activeTab){

      case "inletParameters":

        return (

          <div className="mds-section">

            <h3 className="mds-section-title">
              INLET PARAMETERS
            </h3>

            <div className="mds-grid">

              <DataRow label="Crude Flow" value={crudeFlow} unit="BPM" />
              <DataRow label="Wash Water Flow" value={washWaterFlow} unit="BPM" />
              <DataRow label="Rinse Water Flow" value={rinseWaterFlow} unit="BPM" />
              <DataRow label="Demulsifier Flow" value={demulsifierFlow} unit="L/H" />
              <DataRow label="Decalcifier Flow" value={decalcifierFlow} unit="L/H" />
              <DataRow label="Grid Voltage" value={gridVoltage} unit="kV" />
              <DataRow label="Temperature" value={desalterTemp} unit="°C" />
              <DataRow label="Mix Valve Opening" value={(mixingValveOpening * 100).toFixed(0)} unit="%" />

            </div>

          </div>

        );

      case "inletCrude":

        return (

          <div className="mds-section">

            <h3 className="mds-section-title">
              INLET FROM V-201A
            </h3>

            <div className="mds-grid">

              <DataRow label="Salt" value={inletSalt} unit="PTB" />
              <DataRow label="BS&W" value={inletBSW} unit="%" />
              <DataRow label="Water" value={inletWater} unit="%" />
              <DataRow label="Sediment" value={inletSediment} unit="%" />
              <DataRow label="Inorganic Chlorides" value={inletInorganicChlorides} unit="ppm" />
              <DataRow label="Organic Chlorides" value={inletOrganicChlorides} unit="ppm" />
              <DataRow label="H₂S" value={inletH2S} unit="mg/kg" />

            </div>

          </div>

        );

      case "outletAnalyzer":

        return (

          <div className="mds-section">

            <h3 className="mds-section-title">
              FINAL DESALTED CRUDE
            </h3>

            <div className="mds-grid">

              <DataRow label="Salt" value={FinalSaltOut} unit="PTB" />
              <DataRow label="BS&W" value={FinalBswOut} unit="%" />
              <DataRow label="Water" value={FinalWaterOut} unit="%" />
              <DataRow label="Sediment" value={FinalSedimentOut} unit="%" />
              <DataRow label="Inorganic Chlorides" value={FinalInorganicChloridesOut} unit="ppm" />
              <DataRow label="Organic Chlorides" value={FinalOrganicChloridesOut} unit="ppm" />
              <DataRow label="H₂S" value={FinalH2sOut} unit="mg/kg" />

            </div>

          </div>

        );

      case "performance":

        return (

          <div className="mds-section">

            <h3 className="mds-section-title">
              DESALTER PERFORMANCE
            </h3>

            <div className="mds-grid">

              <DataRow label="Desalter Status" value={desalterStatus} unit="-" />
              <DataRow label="Grid Efficiency" value={gridEfficiency.toFixed(0)} unit="%" />
              <DataRow label="Wash Water Efficiency" value={washEfficiency.toFixed(0)} unit="%" />
              <DataRow label="Mixing Efficiency" value={mixingEfficiency.toFixed(0)} unit="%" />
              <DataRow label="Demulsifier Efficiency" value={demulsifierEfficiency.toFixed(0)} unit="%" />
              <DataRow label="Decalcifier Efficiency" value={decalcifierEfficiency.toFixed(0)} unit="%" />
              <DataRow label="Temperature Efficiency" value={temperatureEfficiency.toFixed(0)} unit="%" />
              <DataRow label="Overall Efficiency" value={overallEfficiency.toFixed(0)} unit="%" />

            </div>

          </div>

        );

      case "upsetMonitor":

        return (

          <div className="mds-section">

            <h3 className="mds-section-title">
              FAILURE / UPSET MONITOR
            </h3>

            <div className="mds-grid">

              {
                upsetConditions.length === 0 ? (

                  <DataRow
                    label="GOOD CONDITION"
                    value="Stable Operation"
                    unit="OK"
                  />

                ) : (

                  upsetConditions.map(
                    (item, index) => (

                      <div
                        key={index}
                        className="mds-row"
                      >

                        <div className="mds-key">
                          {item.title}
                        </div>

                        <div className="mds-value-wrapper">

                          <div
                            className="mds-value-box"
                            style={{
                              width: "100%",
                              minHeight: "55px",
                              whiteSpace: "normal",
                              lineHeight: "18px"
                            }}
                          >
                            {item.impact}
                          </div>

                        </div>

                      </div>

                    )
                  )

                )
              }

            </div>

          </div>

        );

      default:
        return null;

    }

  };

  /* =========================================================
     UI
  ========================================================= */

  return (

    <Rnd

      size={faceplateSize}

      position={faceplatePos}

      onDragStop={(e, d) => {

        setFaceplatePos({
          x: d.x,
          y: d.y
        });

      }}

      onResizeStop={(
        e,
        direction,
        ref,
        delta,
        position
      ) => {

        setFaceplateSize({

          width: ref.offsetWidth,
          height: ref.offsetHeight

        });

        setFaceplatePos(position);

      }}

      minWidth={750}
      minHeight={500}

      bounds="window"

      enableUserSelectHack={false}

      dragHandleClassName="mds-header"

      className="mds-rnd"
    >

      <div
        className="mds-faceplate"
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column"
        }}
      >

        {/* =====================================================
            HEADER
        ===================================================== */}

        <div className="mds-header">

          <div className="mds-title">
            V-201B DESALTER ANALYZER
          </div>

          <button
            className="mds-close-btn"
            onClick={close}
          >
            ✕
          </button>

        </div>

        {/* =====================================================
            BODY
        ===================================================== */}

        <div
          className="mds-body"
          style={{
            flex: 1,
            minHeight: 0
          }}
        >

          {/* =================================================
              LEFT PANEL
          ================================================= */}

          <div className="mds-left-panel">

            {[
              ["inletParameters", "Inlet Parameters"],
              ["inletCrude", "Inlet From V-201A"],
              ["outletAnalyzer", "Final Outlet"],
              ["performance", "Performance"],
              ["upsetMonitor", "Upset Monitor"]
            ].map(([key, label]) => (

              <div
                key={key}

                className={`mds-tab ${
                  activeTab === key
                    ? "active"
                    : ""
                }`}

                onClick={() =>
                  setActiveTab(key)
                }
              >

                {label}

              </div>

            ))}

          </div>

          {/* =================================================
              RIGHT PANEL
          ================================================= */}

          <div
            className="mds-right-panel"
            style={{
              overflowY: "auto",
              overflowX: "hidden",
              paddingRight: "8px",
              flex: 1,
              minHeight: 0
            }}
          >

            {renderSection()}

          </div>

        </div>

        {/* =====================================================
            FOOTER
        ===================================================== */}

        <div className="mds-footer">

          <div className="mds-footer-title">
            NK Refinery DCS and Digital Twin System
          </div>

        </div>

      </div>

    </Rnd>

  );

}

export default AnalyzerV201BFaceplate;